import { useMutation } from '@tanstack/react-query'
import { authApi } from '@/api/auth'
import type { RegisterPayload } from '@/api/auth'

export function useRegister() {
  return useMutation({
    mutationFn: (payload: RegisterPayload) => authApi.register(payload),
  })
}
